$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');

    $(document).pjax('a', {
        container: '#pjax-container',
        fragment: '#pjax-container',
        timeout: 5000,
        cacheBeforeEval: true,
        maxCacheLength: 0
    });

    /*
        INIT
    */
    _this.initPJAX = function() {

        $.pjax.defaults.timeout = 5000;

        if ($.support.pjax) {
            $('a[href$=".pdf"]').addClass('external');

            $(document).pjax('a:not(.external):not([href="#"]):not([rel="external"])', {
                container: '#pjax-container',
                fragment: '#pjax-container',
                cacheBeforeEval: true,
                maxCacheLength: 0
            });

            $(document).on('pjax:start', function() {
                // console.log('pjax:start');
            });

            $(document).on('pjax:beforeReplace', function() {
                // console.log('pjax:beforeReplace');
            });

            $(document).on('pjax:end', function() {
                // console.log('pjax:end');

                // everytime pjax request ends, execute the init again.
                _this.init();
            });

            $(document).on('pjax:popstate', function() {
                window.location.reload();
            });

            $(document).on('pjax:success', function() {
                // console.log('pjax:success');
            });

            $(document).on('pjax:complete', function(event, request) {
                // console.log('pjax:complete');
            });

            $(document).on('pjax:error', function(e, xhr, err) {
                console.log('Something went wrong: ' + err);
            });
        } else {

        }

    }; // end of init

    /**
     * Here goes all code for initialisation of page.
     */
    _this.init = function()
    {
        /**
         *  INIT PLUGINS
         */
        // custom made plugins
        $('#copyright').stickyFooter();
        $('#navigation').navigation(); 

        // Example:
        // <a href="#" title="" class="rel-external">link</a>
        $('.rel-external, a[rel="external"]').on('click', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            window.open(url, '_blank');
        });

        $("#list-images").lightGallery();


        $(document).on('click', '.click', function() {
            console.log('test');
            $('.right-section ').toggleClass('clicked');
        });

        _body.addClass('loaded').removeClass('nav-open');
    };

    /**
     *  If body is loaded already, do not re-init pjax.
     */
    if (!_body.hasClass('loaded'))
    {
        _this.initPJAX();
        _this.init();
    }
});